/**
 * Unauthorized Page
 * Shown when user tries to access a page they don't have permission for
 */

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function Unauthorized() {
  const navigate = useNavigate();
  const { role, signOut } = useAuth();

  const handleGoBack = () => {
    // Redirect based on role
    switch (role) {
      case 'super_admin':
        navigate('/super-admin');
        break;
      case 'company_admin':
        navigate('/admin');
        break;
      case 'company_user':
        navigate('/upload');
        break;
      default:
        navigate('/');
    }
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="container">
      <div className="card" style={{ textAlign: "center", maxWidth: 500, margin: "48px auto", padding: "48px 24px" }}>
        {/* Icon */}
        <div style={{ 
          width: 80, 
          height: 80, 
          margin: "0 auto 24px", 
          borderRadius: "50%", 
          background: "#6b2730",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <span style={{ fontSize: 48 }}>⚠️</span>
        </div>

        {/* Title */}
        <h1 className="title" style={{ marginBottom: 16 }}>
          Acceso Denegado
        </h1>

        {/* Message */}
        <p className="meta" style={{ marginBottom: 32 }}>
          No tienes permisos para acceder a esta página.
          {role && (
            <span style={{ display: "block", marginTop: 12 }}>
              Tu rol actual: <strong>{getRoleDisplay(role)}</strong>
            </span>
          )}
        </p>

        {/* Actions */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <button
            onClick={handleGoBack}
            className="btn"
            style={{ width: "100%" }}
          >
            Volver al inicio
          </button>

          <button
            onClick={handleSignOut}
            className="copy"
            style={{ 
              width: "100%",
              padding: "12px 16px",
              background: "transparent",
              border: "1px solid #273067"
            }}
          >
            Cerrar sesión
          </button>
        </div>

        {/* Help text */}
        <p className="meta" style={{ marginTop: 24, fontSize: 12 }}>
          Si crees que deberías tener acceso a esta página, contacta con tu administrador.
        </p>
      </div>
    </div>
  );
}

function getRoleDisplay(role) {
  const roles = {
    'super_admin': 'Super Administrador',
    'company_admin': 'Administrador de Empresa',
    'company_user': 'Usuario'
  };
  return roles[role] || role;
}

export default Unauthorized;
